import React from 'react';

import { Titulo, TituloH1 } from './styles';

export const TituloPrincipal = ({ containerPadding, listaDeCardsLength, ignoreH1, titulo }) => {
  if (!titulo.titulo) {
    return null;
  }

  if (titulo.principal && !ignoreH1) {
    return (
      <TituloH1
        containerPadding={containerPadding}
        tamanho={
          titulo.tamanhoDoTtulo ? titulo.tamanhoDoTtulo : 'Grande'
        }
        listaDeCardsLength={listaDeCardsLength}
      >
        {titulo.titulo}
      </TituloH1>
    )
  }

  return (
    <Titulo
      containerPadding={containerPadding}
      tamanho={
        titulo.tamanhoDoTtulo ? titulo.tamanhoDoTtulo : 'Grande'
      }
      listaDeCardsLength={listaDeCardsLength}
    >
      {titulo.titulo}
    </Titulo>
  )
}
